// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2Qj-G","infoBtn":"quickbooks_infoBtn__1mYrz","formBox":"quickbooks_formBox__1WA2T","formFooter":"quickbooks_formFooter__TJsJv"};